import { render, staticRenderFns } from "./Modal-limit-purchase.vue?vue&type=template&id=4ae22ca4&scoped=true&lang=pug"
import script from "./Modal-limit-purchase.vue?vue&type=script&lang=js"
export * from "./Modal-limit-purchase.vue?vue&type=script&lang=js"
import style0 from "./Modal-limit-purchase.vue?vue&type=style&index=0&id=4ae22ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae22ca4",
  null
  
)

export default component.exports